import React from 'react';
import { Box, Typography, keyframes } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { LOGIN_ACCENT } from './loginDarkTheme';

const shimmer = keyframes`
  0%, 100% { transform: translateX(-120%) skewX(-12deg); opacity: 0; }
  45% { opacity: 0.85; }
  55% { opacity: 0.85; }
  100% { transform: translateX(220%) skewX(-12deg); opacity: 0; }
`;

const glowPulse = keyframes`
  0%, 100% { filter: drop-shadow(0 0 4px rgba(76, 225, 182, 0.45)); }
  50% { filter: drop-shadow(0 0 10px rgba(76, 225, 182, 0.85)); }
`;

/** Centered tagline below logo — AI icons + glass 3D light reflection. */
export default function AuthPlatformTagline() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 1.75,
        mb: 0.5,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.85,
          px: 1.75,
          py: 0.85,
          borderRadius: '999px',
          overflow: 'hidden',
          background:
            'linear-gradient(145deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.04) 42%, rgba(15,23,42,0.35) 100%)',
          border: '1px solid rgba(255, 255, 255, 0.16)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          boxShadow:
            '0 8px 24px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.22), inset 0 -1px 0 rgba(0,0,0,0.25)',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '-50%',
            left: '-30%',
            width: '45%',
            height: '200%',
            background:
              'linear-gradient(105deg, transparent 0%, rgba(255,255,255,0.35) 48%, transparent 100%)',
            animation: `${shimmer} 4.5s ease-in-out infinite`,
            pointerEvents: 'none',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            borderRadius: 'inherit',
            background:
              'linear-gradient(180deg, rgba(255,255,255,0.12) 0%, transparent 38%, rgba(0,0,0,0.08) 100%)',
            pointerEvents: 'none',
          },
        }}
      >
        <AutoAwesomeIcon
          sx={{
            fontSize: 15,
            color: LOGIN_ACCENT,
            zIndex: 1,
            animation: `${glowPulse} 2.8s ease-in-out infinite`,
          }}
        />
        <Typography
          component="span"
          sx={{
            position: 'relative',
            zIndex: 1,
            fontSize: '0.72rem',
            fontWeight: 700,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            background: `linear-gradient(135deg, #ffffff 0%, ${LOGIN_ACCENT} 52%, #5eead4 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 0 24px rgba(76, 225, 182, 0.25)',
          }}
        >
          AI hospitality platform
        </Typography>
        <AutoAwesomeIcon
          sx={{
            fontSize: 15,
            color: LOGIN_ACCENT,
            zIndex: 1,
            animation: `${glowPulse} 2.8s ease-in-out infinite`,
            animationDelay: '1.4s',
          }}
        />
      </Box>
    </Box>
  );
}
